import { Swiper, Navigation, EffectFade, Pagination } from 'swiper'

Swiper.use([Navigation, EffectFade, Pagination])

const fn = {
  init: () => {
    document.querySelectorAll('.milestones-slider').forEach((el) => fn.setupSlider(el))
  },

  setupSlider: (el) => {
    const textSliderContainer = el.querySelector('.milestones-text-slider .swiper-container')
    const blockSliderContainer = el.querySelector('.milestones-block-slider .swiper-container')

    const numSlides = blockSliderContainer.querySelectorAll('.swiper-slide').length

    const textSwiper = new Swiper(textSliderContainer, {
      autoHeight: true,
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      breakpoints: {
        768: {
          autoHeight: false,
        },
      },
    })

    const blockSliderOpts = {
      slidesPerView: 'auto',
      spaceBetween: 40,
      centeredSlides: true,
      slideToClickedSlide: true,
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesOffsetAfter: 1000,
        },
      },
      on: {
        slideChangeTransitionStart: (swiper) => {
          textSwiper.slideTo(swiper.activeIndex)

          if (swiper.activeIndex > swiper.previousIndex) {
            swiper.slides.forEach((slide, index) => {
              if (index < swiper.activeIndex) {
                slide.classList.add('opacity-0')
              }
            })
          } else {
            swiper.slides.forEach((slide, index) => {
              if (index === swiper.activeIndex) {
                slide.classList.remove('opacity-0')
              }
            })
          }

          swiper.allowSlideNext = swiper.activeIndex < swiper.slides.length
        },
      },
    }

    if (numSlides > 1) {
      blockSliderOpts.navigation = {
        nextEl: blockSliderContainer.querySelector('.milestones-button-next'),
        prevEl: blockSliderContainer.querySelector('.milestones-button-prev'),
      }
    }

    const blockSwiper = new Swiper(blockSliderContainer, blockSliderOpts)

    blockSwiper.snapGrid = [...blockSwiper.slidesGrid]

    const restartBtn = textSliderContainer.querySelector('.milestones-slider-restart')

    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        blockSwiper.slideTo(0)
        blockSwiper.slides.forEach((slide) => slide.classList.remove('opacity-0'))
      })
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
